import { SiteSurvey } from "./types/siteSurvey";

export function getEmptySurvey(): SiteSurvey {
  return {
    address: "",
    city: "",
    clientName: "",
    comments: "",
    customer: "",
    id: null,
    photos: [],
    state: "",
    units: [],
    zip: "",
    modifiedOn: new Date().toJSON(),
    attributes: [],
    technicianId: null,
  };
}
